// @flow
import {
    cleanUpNumberedPointIcon,
    numberedPointIcon,
} from 'esm-web-pro/containers/pages/network/Util';
import L from 'leaflet';
import { get } from 'lodash';
import type { LoadingCallback } from 'esm-web-pro/containers/map/editor/BaseEditor';
import type { LatLng } from 'react-leaflet/lib/types';


const UseHighlightPoint = (
    coordinates?: LatLng,
    number: number,
    identity = '',
    cableReserves: number = undefined,
): LoadingCallback => {
    let callbackLayer = null;

    return {
        run: (layer) => {
            if (get(layer, 'feature.geometry.type') !== 'Point') return;

            if (coordinates) {
                if (layer.getLatLng()
                    .equals(L.latLng(coordinates[1], coordinates[0]))) {
                    layer.setIcon(numberedPointIcon(layer, number, true, cableReserves));
                    callbackLayer = layer;
                }
            } else if (identity) {
                if (layer?.feature?.properties?.point?.identity === identity
                    || layer?.feature?.properties?.identity === identity) {
                    layer.setIcon(numberedPointIcon(layer, number, true, cableReserves));
                    callbackLayer = layer;
                }
            }
        },

        cleanUp: () => {
            if (callbackLayer) {
                callbackLayer.setIcon(cleanUpNumberedPointIcon(callbackLayer));
            }
        },
    };
};

export default UseHighlightPoint;
